import { Avatar, Popover, Typography } from "@mui/material";
import React from "react";

interface Props {
  characterAddress: string;
  characterPosition: string;
  rewardDetails: string;
}

const HighScorePlayer = ({
  characterAddress,
  characterPosition,
  rewardDetails,
}: Props) => {
  const [playerName, setPlayerName] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  var url =
    "https://blockchain-gateway-stillness.live.tech.evefrontier.com/smartcharacters/" +
    characterAddress;

  var playerImage: string = "";

  function getPlayerJSON(json: string) {
    const jsonParsed = JSON.parse(json);
    setPlayerName(jsonParsed.name ? jsonParsed.name : "Unknown player");
    playerImage = jsonParsed.image;
    // playerImage = playerImage.replace(
    //   "https://sandbox-garnet-ipfs-gateway.nursery.reitnorf.com/ipfs/",
    //   "https://mainnet-game-ipfs-gateway.nursery.reitnorf.com/ipfs/"
    // );
    //https://images.dev.quasar.reitnorf.com/Character/123456789_256.jpg
    return jsonParsed;
  }

  if (characterAddress == "") {
    return <></>;
  }

  fetch(url).then((res) => res.text().then((json) => getPlayerJSON(json)));

  return (
    <>
      <Typography
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        component="span"
      >
        <Avatar
          alt="1st"
          src={
            playerImage
              ? playerImage.toString()
              : "https://images.dev.quasar.reitnorf.com/Character/123456789_256.jpg"
          }
          sx={{ width: 56, height: 56 }}
        />
        <div className="font-normal text-xs !py-4">{rewardDetails}</div>
      </Typography>
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: "none" }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {characterPosition} - {playerName}
      </Popover>
    </>
  );
};

export default HighScorePlayer;
